import React, { useState, FC } from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import WidgetsRoundedIcon from "@mui/icons-material/WidgetsRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { useGetContentModelsQuery } from "../../../../../shell/services/instance";
import { DuplicateModelDialogue } from "./DuplicateModelDialogue";
import { DeleteModelDialogue } from "./DeleteModelDialogue";
import { RenameModelDialogue } from "./RenameModelDialogue";
interface Props {
  anchorEl: any;
  onClose: () => void;
  modelZUID: string;
}
export const ModelMenu: FC<Props> = ({
  anchorEl,
  onClose,
  modelZUID
}) => {
  const {
    t
  } = useTranslation();
  const [showDialogue, setShowDialogue] = useState<"rename" | "duplicate" | "delete" | null>(null);
  const [isCopied, setIsCopied] = useState(false);
  const {
    data: models
  } = useGetContentModelsQuery();
  const model = models?.find(model => model.ZUID === modelZUID);
  const handleCopyZUID = (data: string) => {
    navigator?.clipboard?.writeText(data).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1500);
    }).catch(err => {
      console.error(err);
    });
  };
  return <>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose} container={() => document.getElementById(modelZUID)!} data-cy="schema-more-menu" data-sentry-element="Menu" data-sentry-source-file="ModelMenu.tsx">
        <MenuItem onClick={() => {
        setShowDialogue("rename");
        onClose();
      }} data-sentry-element="MenuItem" data-sentry-source-file="ModelMenu.tsx">
          <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="ModelMenu.tsx">
            <DriveFileRenameOutlineRoundedIcon fontSize="small" data-sentry-element="DriveFileRenameOutlineRoundedIcon" data-sentry-source-file="ModelMenu.tsx" />
          </ListItemIcon>
          <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="ModelMenu.tsx">{t("schema.renameModel")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => {
        setShowDialogue("duplicate");
        onClose();
      }} data-sentry-element="MenuItem" data-sentry-source-file="ModelMenu.tsx">
          <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="ModelMenu.tsx">
            <ContentCopyRoundedIcon fontSize="small" data-sentry-element="ContentCopyRoundedIcon" data-sentry-source-file="ModelMenu.tsx" />
          </ListItemIcon>
          <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="ModelMenu.tsx">{t("schema.duplicateModel")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleCopyZUID(model.ZUID)} data-sentry-element="MenuItem" data-sentry-source-file="ModelMenu.tsx">
          <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="ModelMenu.tsx">
            {isCopied ? <CheckRoundedIcon fontSize="small" /> : <WidgetsRoundedIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="ModelMenu.tsx">{t("schema.copyModelZUID")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => {
        setShowDialogue("delete");
        onClose();
      }} data-cy="delete-model-menu-button" data-sentry-element="MenuItem" data-sentry-source-file="ModelMenu.tsx">
          <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="ModelMenu.tsx">
            <DeleteRoundedIcon fontSize="small" data-sentry-element="DeleteRoundedIcon" data-sentry-source-file="ModelMenu.tsx" />
          </ListItemIcon>
          <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="ModelMenu.tsx">{t("schema.deleteModel")}</ListItemText>
        </MenuItem>
      </Menu>

      {showDialogue === "rename" && <RenameModelDialogue model={model} onClose={() => setShowDialogue(null)} />}
      {showDialogue === "duplicate" && <DuplicateModelDialogue model={model} onClose={() => setShowDialogue(null)} />}
      {showDialogue === "delete" && <DeleteModelDialogue model={model} onClose={() => setShowDialogue(null)} />}
    </>;
};